import { Component, OnInit, Input, Output, EventEmitter, HostListener, OnChanges } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { GridViewModel } from 'src/app/shared/models/sectionview.model';
import { ResponseModel } from 'src/app/shared/models/sectionview.model';
import { QuestionViewModel, Option } from 'src/app/shared/models/questionview.model';

import {
  faPlus,
  faMinus
} from '@fortawesome/free-solid-svg-icons';
import { ButtonColors, ButtonSize, ButtonStyle, ButtonType } from 'src/app/shared/components/inputs/button/button.model';
import { DomSanitizer } from '@angular/platform-browser';
import { QuestionFileConfig } from '../../page/page.model';
import { ResponseChangeModel } from 'src/app/incident/incident.component';

@Component({
  selector: 'app-inputType-dynamic-grid',
  templateUrl: './inputType-dynamic-grid.component.html',
  styleUrls: ['./inputType-dynamic-grid.component.scss']
,  standalone: false
})
export class InputTypeDynamicGridComponent implements OnInit, OnChanges {
  @Input('mainQuestion') gridQuestion: QuestionViewModel;

  @Input() header: ResponseModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() foregroundcolor: string;
  @Input() backgroundcolor: string;
  @Input() theme: string;
  @Input() controlBGColor: string;
  @Input() controlBorder: string;
  @Input() TextColor: string;
  @Input() tableBorder: string;
  @Input() IsReadOnly?: boolean = false;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  deletedGridResponses : ResponseModel[]=[];
  finalResponses :GridViewModel;
  
  btnRnd = ButtonType.Round;
  btnPlus = ButtonStyle.PlusIcon;
  btnLarge = ButtonSize.Large;
  btnColor = ButtonColors.Blue;
  maxSequenceNumber: number = 1;
  conditionQues: ConditionalQues[] = [];
  Header: string[];

  constructor(private sanitizer: DomSanitizer) { }

  removeResponse(index: number) {
    
    if (index !== -1) {
      //change sequence numbers for next response objects and remove selected response
      for (let i = index + 1; i < this.gridQuestion.responses.length; i++) {
        this.gridQuestion.responses[i].sequenceNumber = this.gridQuestion.responses[i].sequenceNumber - 1;
      }
      this.gridQuestion.responses.splice(index, 1);
      this.gridQuestion.responseText = JSON.stringify(this.gridQuestion.responses);
      this.inputChange.emit(true);
      this.childQuestion.emit(this.gridQuestion);
    }

  }
  
  InputChange(value:any){
    this.inputChange.emit(value)
  }

  addNewResponse() {

    if(!this.gridQuestion.responses){
      this.gridQuestion.responses = [];
    }
    
    let addResponse = new ResponseModel();
    addResponse.sequenceNumber = this.gridQuestion.responses.length + 1;
    addResponse.questions = [];
    let index = [];
    this.gridQuestion.subQuestions.forEach(element => {
      index.push(element.questionId);
    });
    let maxindex = 0;

    this.gridQuestion.subQuestions.forEach(element => {
      let que = new QuestionViewModel();
      que.questionId = index[maxindex];
      que.lookUpQuestionId = element.questionId;
      que.questionImage = element.questionImage;
      que.parentQuestionId = element.parentQuestionId;
      que.questionImageName = element.questionImageName;
      que.questionText = element.questionText;
      que.questionTextShort = element.questionTextShort;
      que.questionToolTip = element.questionToolTip;
      que.refTableName = element.refTableName;
      que.sectionId = element.sectionId;
      que.sequenceNumber = element.sequenceNumber;
      que.validationDetails = element.validationDetails;
      que.validations = element.validations;
      que.dataType = element.dataType;
      que.defaultResponse = element.defaultResponse;
      // que.inputType="rot";
      que.inputType = element.inputType;
      que.isQuestionRequired = element.isQuestionRequired;
      que.options = [];
      element.options.forEach(elem => {
        let a = new Option;
        a.key = elem.key;
        a.value = elem.value;
        que.options.push(a);
      });


      que.parentQuesResponse = element["parentQuesResponse"];
      // que.responseText = element["responseText"];
      que["initialText"] = element["initialText"];
      que["finalText"] = element["finalText"];
      que["responseText"] = null;
      que.maxLength = element.maxLength;
      maxindex = maxindex + 1;

      addResponse.questions.push(que);
      addResponse.isDefaultControl = false;
    });

    this.gridQuestion.responses.push(addResponse);
    this.maxSequenceNumber = this.gridQuestion.responses.length;
    this.handleDateQuestions();
    this.childQuestion.emit(this.gridQuestion);
    this.inputChange.emit(true);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['gridQuestion'] && changes['gridQuestion'].currentValue) {
      const currentQuestion = changes['gridQuestion'].currentValue;
      this.gridQuestion = { ...currentQuestion }; // Create a new reference to trigger change detection
      this.ensureAllResponsesHaveSubQuestions();
      this.childQuestion.emit(this.gridQuestion);
    }
  }
  ngOnInit() {
    //console.log("response s : ",this.gridQuestions.response);
    console.log('mainQuestion : ', this.gridQuestion);
    
    // Auto-add one row if grid is required and has no rows
    if (this.gridQuestion.isQuestionRequired === 'Y' && 
        (!this.gridQuestion.responses || this.gridQuestion.responses.length === 0)) {
      this.addNewResponse();
    }
  }
  ensureAllResponsesHaveSubQuestions() {
    if (!this.gridQuestion.responses?.length) return;

      // Get template from first subquestion structure
      const subQuestionTemplate = this.gridQuestion.subQuestions.map(element => ({
        questionId: element.questionId,
        lookUpQuestionId: element.questionId,
        questionImage: element.questionImage,
        parentQuestionId: element.parentQuestionId,
        questionText: element.questionText,
        questionTextShort: element.questionTextShort,
        questionToolTip: element.questionToolTip,
        refTableName: element.refTableName,
        sectionId: element.sectionId,
        sequenceNumber: element.sequenceNumber,
        validationDetails: element.validationDetails,
        validations: element.validations,
        dataType: element.dataType,
        defaultResponse: element.defaultResponse,
        inputType: element.inputType,
        isQuestionRequired: element.isQuestionRequired,
        options: element.options?.map(opt => ({
          key: opt.key,
          value: opt.value
        })) || [],
        responseText: null,
        maxLength: element.maxLength
      }));

      // Ensure each response has all subquestions
      this.gridQuestion.responses.forEach(response => {
        if (!response.questions) {
          response.questions = [];
        }

        // Find missing subquestions and update existing ones with validationDetails
        subQuestionTemplate.forEach(template => {
          const existingQuestion = response.questions.find(q => q.questionId === template.questionId);
          if (!existingQuestion) {
            response.questions.push({
              ...template,
              parentQuestionGuid: '',
              parentQuesResponse: '',
              sectionGuid: '',
              questionImageName: '',
              isParentQuestionVisible: false,
              isSecParentQuestionVisible: false,
              questionGuid: '',
              displayMode: '',
              enableQuestion: false,
              comments: '',
              errorMessage: '',
              questionIndex: 0,
              subQuestions: [],
              resetFlag: false,
              questionFileConfig: new QuestionFileConfig,
              responses: [],
              isConsentQuestion: false,
              consentQuestionLabel: '',
              questionSignTypes: [],
              isESignRequired: false,
              isSSignRequired: false,
            });}
           else {
            // Update existing question with validationDetails from template (may be missing from saved JSON)
            existingQuestion.validationDetails = template.validationDetails;
            existingQuestion.validations = template.validations;
            existingQuestion.isQuestionRequired = template.isQuestionRequired;
            existingQuestion.maxLength = template.maxLength;
          }
        });
      });
    
    // Update the grid question
    this.childQuestion.emit(this.gridQuestion);
  }
  

  handleDateQuestions() {
    this.gridQuestion.responses.forEach((element) => {
      element.questions.forEach((subElement) => {
        if (subElement.inputType == 'dte') {
          subElement.todayDateEnabled = true;
          subElement.pastDateEnabled = true;
        }
      })
    })
  }


  GetChildData(selectedChild: any, responseIndex: number) {
   
    // Update the specific subquestion first
    this.gridQuestion.responses[responseIndex].questions.forEach((element, rowIndex) => {
      if (element.questionId == selectedChild.questionId) {
        //element.responseText = selectedChild.responseText;
        Object.assign(element, selectedChild);
      }
    });

    this.gridQuestion.subQuestions.forEach((element, rowIndex) => {
      if (element.questionId == selectedChild.questionId) {     
        Object.assign(element, selectedChild);     
      }
    });

    // Now check validation for the entire dynamic grid
    let isValid = true;
    let hasValidationErrors = false;
    
    // For dynamic grids, validate the responses array
    if (this.gridQuestion.responses && this.gridQuestion.responses.length > 0) {
      this.gridQuestion.responses.forEach((response) => {
        if (response.questions && response.questions.length > 0) {
          response.questions.forEach((subQuestion) => {
            // Check for validation errors
            if (subQuestion['IsValid'] === false || 
                (subQuestion.errorMessage && subQuestion.errorMessage.length > 0)) {
              hasValidationErrors = true;
              isValid = false;
            }
          });
        }
      });
    }
    
    // Set the main grid question validation status
    this.gridQuestion['IsValid'] = isValid;    
  
    this.gridQuestion.responseText = JSON.stringify(this.gridQuestion.responses);
    this.childQuestion.emit(this.gridQuestion);
  }
  
  
  isConditionalCheck(data: ResponseChangeModel) {
    if(data == null || data.question == null){
      return;
    }
    const currQues: QuestionViewModel = data.question;
    const proceedCallback = data.proceed || (() => {});

    if(currQues.inputType === 'mul' || currQues.inputType === 'chk' || currQues.inputType === 'rdo' || currQues.inputType === 'cmb') {
      proceedCallback(true);
    }    
  }
 

toggleSelection(question: QuestionViewModel, option:string,rowIndex:number,columnIndex :number) {
  let selectedOption ='' 
  if(question.responseText==option){
  question.responseText = null;
  selectedOption = null;
  }else{
    question.responseText = option;
    selectedOption = option;
  }
this.gridQuestion.responses[rowIndex].questions[columnIndex].responseText = selectedOption;
this.childQuestion.emit(this.gridQuestion);
}

}
export class ConditionalQues {
  que: string;
  value: string;
  isSelected?: boolean = false;
}